import { useTranslation } from "react-i18next";
import { ColorSpinner, ContentLoader, Text } from "shared/components/Spor";
import { SectionStateContentSize } from "shared/components/states/SectionStateContent";
import { StateContentContainer } from "shared/components/states/StateContentContainer";

type LoadingProps = {
  backgroundColor?: string;
  size?: SectionStateContentSize;
  borderRadius?: string;
};

const Content = ({ size }: { size: SectionStateContentSize }) => {
  const { t } = useTranslation();

  if (size === "sm") {
    return (
      <>
        <ColorSpinner width="50px" />

        <Text variant="sm" my="auto">
          {t("Laster innhold")}
        </Text>
      </>
    );
  }

  if (size === "lg") {
    return (
      <>
        <ContentLoader width="150px" />
        <Text my={0} textAlign="center" variant="md-lg">
          {t("Laster innhold")}
        </Text>
      </>
    );
  }

  /* md */
  return (
    <>
      <ColorSpinner width="50px" />
      <Text my={0} textAlign="center" variant="sm">
        {t("Laster innhold")}
      </Text>
    </>
  );
};

export const LoadingContent = ({
  backgroundColor,
  size = "md",
  borderRadius,
}: LoadingProps) => (
  <StateContentContainer
    size={size}
    backgroundColor={backgroundColor}
    borderRadius={borderRadius}
  >
    <Content size={size} />
  </StateContentContainer>
);
